export function getNestedError(rootObject: any, path: string) {
  // Function for navigating objects by a 'string path' eg deeply.nested.object.value
  // Useful for name paths as part of react form and fetching the appropriate field error object
  return path.split('.').reduce((acc, part) => acc?.[part], rootObject)
}


export function getEnumValue<T extends Record<string, string | number>>(
  enumObj: T,
  input: number | string | undefined | null
): T[keyof T] | undefined {
  if (input === undefined || input === null) {
    return undefined
  }
  if (typeof input === 'string') {
    const asInt = Number.parseInt(input)
    if (Number.isNaN(asInt)) {
      return undefined
    }
    input = asInt
  }
  const values = Object.values(enumObj).filter(v => typeof v === 'number')
  return values.includes(input) ? (input as T[keyof T]) : undefined
}